export const SOURCES = {
  CRAIGSLIST: "craigslist",
  KIJIJI: "kijiji",
  VANSKY: "vansky",
};

export const LOCATIONS = {
  VANCOUVER: "Vancouver",
  BURNABY: "Burnaby",
  RICHMOND: "Richmond",
  COQUITLAM: "Coquitlam",
  // WEST_VANCOUVER: "West Vancouver",
  // NORTH_VANCOUVER: "North Vancouver",
  WHITE_ROCK: "White Rock",
  NEW_WESTMINSTER: "New Westminster",
  LANGLEY: "Langley",
  DELTA: "Delta",
  MAPLE_RIDGE: "Maple Ridge",
  SURREY: "Surrey",
  // OTHERS: "Others",
};

export const HOUSE_TYPES = {
  APARTMENT: "Apartment",
  HOUSE: "House",
  TOWNHOUSE: "Townhouse",
  BASEMENT: "Basement",
  // OTHERS: "Others",
};

export const FAKE_LISTINGS = [];

export const PAGE_LIMIT = 40;
